// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import CreateConsultingCaseRequestViewModel from '../../viewModel/resource/CreateConsultingCaseRequestViewModel';
import ConsultingCaseListResourceListResultViewModel from '../../viewModel/resource/ConsultingCaseListResourceListResultViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async addConsultingCase(model: CreateConsultingCaseRequestViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-add-consulting-case'] ?? 'ConsultingCases';
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as number | undefined;
  },
  /**  */
  async getConsultingCasesByUser(userId: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-consulting-cases-by-user'] ?? 'ConsultingCases/{userId}';
    endpointPath = endpointPath.replace(/\{userId\}/g, `${userId}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new ConsultingCaseListResourceListResultViewModel().fromDTO(dto);
  },
});
